/**
 * In a string, replace all text that is a backslash \ into a new line.
 * \ into a tag <br>"
 */
export const convertMarkdownStyleLineBreaksToHtml = (inputString = '') => {
  if (!inputString) {
    return '';
  }

  return inputString.replaceAll(/\\/g, () => {
    return `<br>`;
  });
};
